module.exports = __webpack_public_path__ + "img/title3.83c3daad.png";